import { Controller } from "@hotwired/stimulus"
import debounce from "debounce";

// Connects to data-controller="datatable"
export default class extends Controller {
  static targets = ["select2api"]
  initialize() {
    this.submit = debounce(this.submit.bind(this), 300);
  }

  connect() {
    this.select2apiTargets.forEach((element) => this.select2api(element));
  }

  disconnect() {
    this.select2apiTargets.forEach((element) => {
      if ($(element).data('select2')) {
        $(element).select2('destroy');
      }
    });
  }

  submit(event) {
    if (event && event.target && ($(event.target).hasClass('select2-search__field') || $(event.target).hasClass('select2-input'))) {
      return;
    }

    app.datatable.loading(this.scope.element.getAttribute('data-target'));
    this.element.requestSubmit();
  }

  select2api(element) {
    if ($(element).data('select2')) {
      $(element).select2('destroy');
    }

    $(element).select2({
      placeholder: element.dataset.placeholder,
      allowClear: true,
      width: '100%',
      ajax: {
        url: element.dataset.url,
        dataType: 'json',
        delay: 250,
        cache: false,
        data: function(params) {
          const term = params.term || params;

          return { q: term, term: term };
        },
        processResults: function(data) {
          if (data.results) {
            return data;
          }

          return { results: data };
        }
      }
    }).off('select2:select select2:clear').on('select2:select select2:clear', () => {
      this.submit();
    });
  }
}
